/**
 * URL-hash keys for the roles feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const ROLES_HASH = {
  /** `#create` — RoleFormDialog in create mode. */
  create: 'create',
  /** `#edit/<id>` — RoleFormDialog editing a specific role. */
  edit: 'edit',
  /** `#delete/<id>` — single-role delete confirmation. */
  delete: 'delete',
  /** `#assign/<id>` — AssignRoleDialog for a specific role. */
  assign: 'assign',
  /**
   * `#permissions/<id>` — RolePermissionsPanel: the one place a role's
   * permissions are edited, action and view/column alike. The old
   * `#view-permissions/<id>` overlay folded into its second tab.
   */
  permissions: 'permissions',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete',
  /** `#bulk-assign` — bulk assign-permissions dialog (action bar). */
  bulkAssign: 'bulk-assign'
} as const;

export type RolesHashKey = (typeof ROLES_HASH)[keyof typeof ROLES_HASH];
